/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Question,
    QuestionFromJSON,
    QuestionFromJSONTyped,
    QuestionToJSON,
} from './';

/**
 * Detalle de oferta [P_E_05] [P_E_12]
 * @export
 * @interface CompanyOffer
 */
export interface CompanyOffer {
    /**
     * 
     * @type {number}
     * @memberof CompanyOffer
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyOffer
     */
    displayCompanyName?: boolean;
    /**
     * Nombre a mostrar en caso de que no se quiera mostrar empresa
     * @type {string}
     * @memberof CompanyOffer
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyOffer
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyOffer
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyOffer
     */
    externalUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyOffer
     */
    expireAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyOffer
     */
    requirements?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyOffer
     */
    maxJobs?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyOffer
     */
    dept?: string;
    /**
     * normal, fct, dual
     * @type {string}
     * @memberof CompanyOffer
     */
    modality?: string;
    /**
     * on_site, semi, remote
     * @type {string}
     * @memberof CompanyOffer
     */
    presence?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyOffer
     */
    date?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyOffer
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyOffer
     */
    city?: string;
    /**
     * Id Provincia
     * @type {number}
     * @memberof CompanyOffer
     */
    state?: number;
    /**
     * id tipo de contrato
     * @type {number}
     * @memberof CompanyOffer
     */
    contractType?: number;
    /**
     * duración del trabajo
     * @type {string}
     * @memberof CompanyOffer
     */
    length?: string;
    /**
     * id del horario
     * @type {number}
     * @memberof CompanyOffer
     */
    schedule?: number;
    /**
     * bruto año, neto al mes, ...
     * @type {string}
     * @memberof CompanyOffer
     */
    salaryType?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyOffer
     */
    salaryMin?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyOffer
     */
    salaryMax?: number;
    /**
     * array de strings en json
     * @type {string}
     * @memberof CompanyOffer
     */
    benefits?: string;
    /**
     * otros beneficios
     * @type {string}
     * @memberof CompanyOffer
     */
    benefitsText?: string;
    /**
     * lista de ids, tiraremos de fixtures
     * @type {Array<number>}
     * @memberof CompanyOffer
     */
    academicPrograms?: Array<number>;
    /**
     * Acepta alumnos que no hayan acabado el ciclo
     * @type {boolean}
     * @memberof CompanyOffer
     */
    acceptUnfinished?: boolean;
    /**
     * unpublished, published, closed
     * @type {string}
     * @memberof CompanyOffer
     */
    status?: string;
    /**
     * El proceso de selección es todo remoto
     * @type {boolean}
     * @memberof CompanyOffer
     */
    isRemoteProcess?: boolean;
    /**
     * Ya hay gente que aplico en la oferta
     * @type {boolean}
     * @memberof CompanyOffer
     */
    hasApplications?: boolean;
    /**
     * 
     * @type {Array<Question>}
     * @memberof CompanyOffer
     */
    questions?: Array<Question>;
    /**
     * count applications group by status
     * @type {Array<object>}
     * @memberof CompanyOffer
     */
    counts?: Array<object>;
}

export function CompanyOfferFromJSON(json: any): CompanyOffer {
    return CompanyOfferFromJSONTyped(json, false);
}

export function CompanyOfferFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyOffer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'displayCompanyName': !exists(json, 'display_company_name') ? undefined : json['display_company_name'],
        'companyName': !exists(json, 'company_name') ? undefined : json['company_name'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'externalUrl': !exists(json, 'external_url') ? undefined : json['external_url'],
        'expireAt': !exists(json, 'expire_at') ? undefined : json['expire_at'],
        'requirements': !exists(json, 'requirements') ? undefined : json['requirements'],
        'maxJobs': !exists(json, 'max_jobs') ? undefined : json['max_jobs'],
        'dept': !exists(json, 'dept') ? undefined : json['dept'],
        'modality': !exists(json, 'modality') ? undefined : json['modality'],
        'presence': !exists(json, 'presence') ? undefined : json['presence'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'zip': !exists(json, 'zip') ? undefined : json['zip'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'contractType': !exists(json, 'contract_type') ? undefined : json['contract_type'],
        'length': !exists(json, 'length') ? undefined : json['length'],
        'schedule': !exists(json, 'schedule') ? undefined : json['schedule'],
        'salaryType': !exists(json, 'salary_type') ? undefined : json['salary_type'],
        'salaryMin': !exists(json, 'salary_min') ? undefined : json['salary_min'],
        'salaryMax': !exists(json, 'salary_max') ? undefined : json['salary_max'],
        'benefits': !exists(json, 'benefits') ? undefined : json['benefits'],
        'benefitsText': !exists(json, 'benefits_text') ? undefined : json['benefits_text'],
        'academicPrograms': !exists(json, 'academic_programs') ? undefined : json['academic_programs'],
        'acceptUnfinished': !exists(json, 'accept_unfinished') ? undefined : json['accept_unfinished'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'isRemoteProcess': !exists(json, 'is_remote_process') ? undefined : json['is_remote_process'],
        'hasApplications': !exists(json, 'has_applications') ? undefined : json['has_applications'],
        'questions': !exists(json, 'questions') ? undefined : ((json['questions'] as Array<any>).map(QuestionFromJSON)),
        'counts': !exists(json, 'counts') ? undefined : json['counts'],
    };
}

export function CompanyOfferToJSON(value?: CompanyOffer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'display_company_name': value.displayCompanyName,
        'company_name': value.companyName,
        'title': value.title,
        'text': value.text,
        'external_url': value.externalUrl,
        'expire_at': value.expireAt,
        'requirements': value.requirements,
        'max_jobs': value.maxJobs,
        'dept': value.dept,
        'modality': value.modality,
        'presence': value.presence,
        'date': value.date,
        'zip': value.zip,
        'city': value.city,
        'state': value.state,
        'contract_type': value.contractType,
        'length': value.length,
        'schedule': value.schedule,
        'salary_type': value.salaryType,
        'salary_min': value.salaryMin,
        'salary_max': value.salaryMax,
        'benefits': value.benefits,
        'benefits_text': value.benefitsText,
        'academic_programs': value.academicPrograms,
        'accept_unfinished': value.acceptUnfinished,
        'status': value.status,
        'is_remote_process': value.isRemoteProcess,
        'has_applications': value.hasApplications,
        'questions': value.questions === undefined ? undefined : ((value.questions as Array<any>).map(QuestionToJSON)),
        'counts': value.counts,
    };
}


